[
  {
    "url": "https://[\\w.-]+\\.salesforce\\.com/003\\w+",
    "elements": [
      {
        "name": "Full Name",
        "selector": ".pageDescription"
      },
      {
        "name": "Contact Email",
        "selector": "table.detailList a[href^='mailto:']"
      }
    ]
  },
  {
    "url": "https://[\\w.-]+\\.salesforce\\.com/001\\w+",
    "elements": [
      {
        "name": "Company Website",
        "selector": "table.detailList a[target='_blank']"
      }
    ]
  },
  {
    "url": "https://[\\w.-]+\\.salesforce\\.com/00q\\w+",
    "elements": [
      {
        "name": "Full Name",
        "selector": ".pageDescription"
      },
      {
        "name": "Contact Email",
        "selector": "table.detailList a[href^='mailto:']"
      }
    ]
  }
]
